import React, { ReactNode } from "react";
import { useHistory } from "react-router";
import styles from "./overlayButton.module.scss";
import { LocationDescriptor } from "history";

interface Props {
  children: ReactNode;
  onClick?: () => void;
  onAsLinkClick?: () => void;
  asLink?: boolean;
  to?: string | LocationDescriptor;
  overlayClass?: string;
}

const OverlayButton = ({ children, onClick, onAsLinkClick, asLink, to, overlayClass }: Props) => {
  // history
  const history = useHistory();

  // handlers
  const onClickHandler = () => {    
    if (asLink && to) {
      if(onAsLinkClick) onAsLinkClick();

      history.push(to);
    } else if (onClick) {
      onClick();
    } 
  }
  
  // render
  return (
    <div className="positon-relative">
      <div
        className={`${styles.overlay}${overlayClass ? " " + overlayClass : ""}`}
        onClick={onClickHandler}
      />
      {children}
    </div>
  );
};

export default OverlayButton;
